<template>
  <div id="toolbar" class="row align-items-center justify-content-between" >
    <div class="col-sm-12 col-md-8">
      <template>
        <span id="toolbar-forward-email">
          <fontAwesomeIcon @click="modalCreator({id: 'emailModal', title: t('documentsSearchEmailModalHead','documentsSearchEmailModalHead'), level: 'main', open: 'open', entries: entries, wm: 'none', perm_wm_allowed: true}, documentsData, $event.target)"
          :icon="['fa', 'at']" size="2x" class="showhand mx-2 align-middle toolbar-hover"/>
        </span>
        <b-popover target="toolbar-forward-email" triggers="hover" placement="bottomleft">
          <template v-slot:title>{{t('documentsToolbarEmail','documentsToolbarEmail')}}</template>
          {{t('documentsToolbarEmailDesc','documentsToolbarEmailDesc')}}
        </b-popover>
      </template>
      <span v-if="(Number(userLevel) > 0.50)">
        <template>
          <span id="toolbar-forward-fax">
            <fontAwesomeIcon @click="modalCreator({id: 'faxModal', title: t('documentsSearchFaxModalHead','documentsSearchFaxModalHead'), level: 'main', open: 'open', entries: entries, type: 'default'}, documentsData, $event.target)"
            :icon="['fa', 'fax']" size="2x" class="showhand mx-2 align-middle"/>
          </span>
          <b-popover target="toolbar-forward-fax" triggers="hover" placement="bottomleft">
            <template v-slot:title>{{t('documentsToolbarFax','documentsToolbarFax')}}</template>
            {{t('documentsToolbarFaxDesc','documentsToolbarFaxDesc')}}
          </b-popover>
        </template>
        <template>
          <span id="toolbar-forward-post">
            <fontAwesomeIcon @click="documentsToolSelected('post', $event.target)"
            :icon="['fa', 'envelope']" size="2x" class="showhand mx-2 align-middle"/>
          </span>
          <b-popover target="toolbar-forward-post" triggers="hover" placement="bottomleft">
            <template v-slot:title>{{t('documentsToolbarPost','documentsToolbarPost')}}</template>
            {{t('documentsToolbarPostDesc','documentsToolbarPostDesc')}}
          </b-popover>
        </template>
      </span>
      <template>
        <span id="toolbar-local-download">
          <fontAwesomeIcon :disabled="documentsMerging" @click="documentsToolSelected('download-default', $event.target)" :icon="['fa', 'file-pdf']" size="2x" class="showhand mx-2 align-middle"/>
          <!--<fontAwesomeIcon :icon="['fa', 'file-pdf']" size="2x" class="mx-2 align-middle text-faded-gray"/>-->
        </span>
        <b-popover target="toolbar-local-download" triggers="hover" placement="bottomleft">
          <template v-slot:title>{{t('documentsToolbarPdf','documentsToolbarPdf')}}</template>
          {{t('documentsToolbarPdfDesc','documentsToolbarPdfDesc')}}
        </b-popover>
      </template>
      <span v-if="clientName == 'tota'">
        <span id="toolbar-sel-export-consolidated-sheet">
          <!--<fontAwesomeIcon @click="documentsToolSelected('download-consolidated', $event.target)" :icon="['far', 'file-pdf']" size="2x" class="showhand mx-2 align-middle"/>-->
          <fontAwesomeIcon :icon="['far', 'file-pdf']" size="2x" class="mx-2 align-middle text-faded-gray"/>
        </span>
        <!--
        <b-popover target="toolbar-sel-export-consolidated-sheet" triggers="hover" placement="bottomleft">
          <template v-slot:title>{{t('documentsToolbarPdfMulti','documentsToolbarPdfMulti')}}</template>
          {{t('documentsToolbarPdfMultiDesc','documentsToolbarPdfMultiDesc')}}
        </b-popover>
      -->
      </span>
      <span v-if="(Number(userLevel) > 1.60)">
        <!-- NS-10074 Delete should be available only to newsnet users -->
        <!-- EIPP-199 Delete available to SA ( in proof batch ) and Newsnet users, PW -->
        <span v-if="(Number(userLevel) >= 2.50 && proof == 'proof') || (Number(userLevel) == 3.00)">
          <template v-if="!displaySettings.hideDeleteOption">
            <span id="toolbar-delete">
              <!--<fontAwesomeIcon @click="documentsToolSelected('delete', $event.target)" :icon="['fa', 'trash-alt']" size="2x" class="showhand mx-2 align-middle"/>-->
              <fontAwesomeIcon @click="modalCreator({id: 'deleteModal', title: t('documentsSearchDeleteModalHead','documentsSearchDeleteModalHead'), level: 'main', open: 'open', entries: 'multi', type: 'default'}, documentsData, $event.target)" :icon="['fa', 'trash-alt']" size="2x" class="showhand mx-2 align-middle"/>
            </span>
            <b-popover target="toolbar-delete" triggers="hover" placement="bottomleft">
              <template v-slot:title>{{t('documentsToolbarDelete','documentsToolbarDelete')}}</template>
              {{t('documentsToolbarDeleteDesc','documentsToolbarDeleteDesc')}}
            </b-popover>
          </template>
        </span>
        <template>
          <span id="toolbar-mark-read">
            <fontAwesomeIcon @click="documentsToolSelected('mark-read', $event.target)" :icon="['fa', 'book-open']" size="2x" class="showhand mx-2 align-middle"/>
          </span>
          <b-popover target="toolbar-mark-read" triggers="hover" placement="bottomleft">
            <template v-slot:title>{{t('documentsToolbarMarkRead','documentsToolbarMarkRead')}}</template>
            {{t('documentsToolbarMarkReadDesc','documentsToolbarMarkReadDesc')}}
          </b-popover>
        </template>
        <template v-if="(Number(userLevel) > 2.50)">
          <span id="toolbar-mark-hidden-newsnet">
            <fontAwesomeIcon @click="documentsToolSelected('mark-newsnet_hidden', $event.target)" :icon="['far', 'eye-slash']" size="2x" class="showhand mx-2 align-middle"/>
          </span>
          <b-popover target="toolbar-mark-hidden-newsnet" triggers="hover" placement="bottomleft">
            <template v-slot:title>{{t('documentsToolbarNewsnetHide','documentsToolbarNewsnetHide')}}</template>
            {{t('documentsToolbarNewnetHideDesc','documentsToolbarNewnetHideDesc')}}
          </b-popover>
        </template>
        <template v-if="Number(userLevel) >= 2.00">
          <span id="toolbar-mark-hidden">
            <fontAwesomeIcon @click="documentsToolSelected('mark-hidden', $event.target)" :icon="['fa', 'eye-slash']" size="2x" class="showhand mx-2 align-middle"/>
          </span>
          <b-popover target="toolbar-mark-hidden" triggers="hover" placement="bottomleft">
            <template v-slot:title>{{t('documentsToolbarHide','documentsToolbarHide')}}</template>
            {{t('documentsToolbarHideDesc','documentsToolbarHideDesc')}}
          </b-popover>
        </template>
      </span>
      <template>
        <span id="toolbar-list-all">
          <fontAwesomeIcon @click="listAll()" :icon="['fa', 'clipboard-list']" size="2x" class="showhand mx-2 align-middle"/>
        </span>
        <b-popover target="toolbar-list-all" triggers="hover" placement="bottomleft">
          <template v-slot:title>{{t('documentsToolbarListAll','documentsToolbarListAll')}}</template>
          {{t('documentsToolbarListAllDesc','documentsToolbarListAllDesc')}}
        </b-popover>
      </template>
      <span v-if="(displaySettings.selViewReq == 1) || (Number(userLevel) > 1.60)">
        <template>
          <span id="toolbar-sel-view">
            <fontAwesomeIcon @click="documentsToolSelected('view-sel')" :icon="['fa', 'clipboard-check']" size="2x" class="showhand mx-2 align-middle"/>
          </span>
          <b-popover target="toolbar-sel-view" triggers="hover" placement="bottomleft">
            <template v-slot:title>{{t('documentsToolbarViewSelected','documentsToolbarViewSelected')}}</template>
            {{ t('documentsToolbarViewSelectedDesc','documentsToolbarViewSelectedDesc') }}
          </b-popover>
        </template>
        <!--<span v-if="docTypesOnPageInclude('Invoice')">-->
        <span>
          <span v-if="(displaySettings.selViewReq == 1) || (Number(userLevel) >= 2.00)" id="toolbar-sel-export">
            <fontAwesomeIcon :disabled="csvGenerating" @click="documentsToolSelected('download-sumcsv', $event.target)" :icon="['fa', 'file-csv']" size="2x" class="showhand mx-2 align-middle"/>
<!--            <fontAwesomeIcon :icon="['fa', 'file-csv']" size="2x" class="mx-2 align-middle text-faded-gray"/>-->
          </span>
          <b-popover target="toolbar-sel-export" triggers="hover" placement="bottomleft">
            <template v-slot:title>{{t('documentsToolbarCSV','documentsToolbarCSV')}}</template>
            {{t('documentsToolbarCSVDesc','documentsToolbarCSVDesc')}}
          </b-popover>
        </span>
        <!--<span v-if="docTypesOnPageInclude('Invoice')">-->
        <span>
          <span id="toolbar-data-download">
            <fontAwesomeIcon @click="documentsToolSelected('download-data', $event.target)" :icon="['fa', 'file-alt']" size="2x" class="showhand mx-2 align-middle"/>
<!--            <fontAwesomeIcon :icon="['fa', 'file-alt']" size="2x" class="mx-2 align-middle text-faded-gray"/>-->
          </span>
          <b-popover target="toolbar-data-download" triggers="hover" placement="bottomleft">
            <template v-slot:title>{{t('documentsToolbarData','documentsToolbarData')}}</template>
            {{t('documentsToolbarDataDesc','documentsToolbarDataDesc')}}
          </b-popover>
        </span>

        <span v-if="(userLevel >= 2.00) && displaySettings.zipDownload">
          <span id="toolbar-zip">
            <!--<fontAwesomeIcon @click="documentsToolSelected('download-zip', $event.target)" :icon="['fa', 'file-archive']" size="2x" class="showhand mx-2 align-middle"/>-->
            <fontAwesomeIcon v-if="!zipGenerating" @click="documentsToolSelected('download-zip', $event.target)" :icon="['fa', 'file-archive']" size="2x" class="showhand mx-2 align-middle"/>
            <fontAwesomeIcon v-else-if="zipGenerating" :icon="['fa', 'file-archive']" size="2x" class="showhand mx-2 align-middle text-faded-gray"/>
          </span>
          <b-popover target="toolbar-zip" triggers="hover" placement="bottomleft">
            <template v-slot:title>{{t('documentsToolbarZip','documentsToolbarZip')}}</template>
            {{t('documentsToolbarZipDesc','documentsToolbarZipDesc')}}
          </b-popover>
        </span>

        <!-- NS-9694 Hiding payment for non-SME on TOTA -->
        <template v-if="payment_available_for_documents_on_page">
          <!-- NS-9511 DL - new functionality for online payments	-->
          <span v-if="is_payment_on">
            <span id="toolbar-payment">
              <fontAwesomeIcon @click="documentsToolSelected('contact-payitems', $event.target)" :icon="['fa', 'credit-card']" size="2x" class="showhand mx-2 align-middle"/>
            </span>
            <b-popover target="toolbar-payment" triggers="hover" placement="bottomleft">
              <template v-slot:title>{{t('documentsToolbarPayment','documentsToolbarPayment')}}</template>
              {{t('documentsToolbarPaymentDesc','documentsToolbarPaymentDesc')}}
            </b-popover>
          </span>
        </template>
        <span v-if="is_payment_on">
          <span id="toolbar-online-statement">
            <fontAwesomeIcon @click="unpaid()" :icon="['fas', 'wallet']" size="2x" class="showhand mx-2 align-middle"/>
          </span>
          <b-popover target="toolbar-online-statement" triggers="hover" placement="bottomleft">
            <template v-slot:title>{{t('documentsToolbarStatements','documentsToolbarStatements')}}</template>
            {{t('documentsToolbarStatementsDesc','documentsToolbarStatementsDesc')}}
          </b-popover>
        </span>
        <span v-if="(displaySettings.enableContactDropdown && displaySettings.enableContactDropdown.enabled)&& (displaySettings.enableContactDropdown.raiseQuery || displaySettings.enableContactDropdown.notifyRemittance)">
          <span v-if="displaySettings.enableContactDropdown.raiseQuery">
            <span id="toolbar-raise-query">
              <fontAwesomeIcon @click="modalCreator({id: 'queryModal', title: t('documentsSearchRaiseQueryModalHead', 'documentsSearchRaiseQueryModalHead'), level: 'main', open: 'open', entries: 'multi'}, documentsData, $event.target)"
              :icon="['fa', 'comments']" size="2x" class="showhand mx-2 align-middle"/>
            </span>
            <b-popover target="toolbar-raise-query" triggers="hover" placement="bottomleft">
              <template v-slot:title>{{t('documentsToolbarQuery','documentsToolbarQuery')}}</template>
              {{t('documentsToolbarQueryDesc','documentsToolbarQueryDesc')}}
            </b-popover>
          </span>
          <span v-if="displaySettings.enableContactDropdown.notifyRemittance">
            <span id="toolbar-notify-remittance">
              <fontAwesomeIcon @click="modalCreator({id: 'notifyModal', title: t('documentsSearchNotifyRemittanceModalHead', 'documentsSearchNotifyRemittanceModalHead'), level: 'main', open: 'open', entries: 'multi'}, documentsData, $event.target)"
              :icon="['fa', 'bell']" size="2x" class="showhand mx-2 align-middle"/>
            </span>
            <b-popover target="toolbar-notify-remittance" triggers="hover" placement="bottomleft">
              <template v-slot:title>{{t('documentsToolbarNotify','documentsToolbarNotify')}}</template>
              {{t('documentsToolbarNotifyDesc','documentsToolbarNotifyDesc')}}
            </b-popover>
          </span>
        </span>
        <!--<span v-if="clientName == 'look'">
          <span id="toolbar-unpaid">
            <fontAwesomeIcon @click="unpaid()" :icon="['fas', 'wallet']" size="2x" class="showhand mx-2 align-middle"/>
            <fontAwesomeIcon :icon="['fas', 'wallet']" size="2x" class="mx-2 align-middle text-faded-gray"/>
          </span>
          <b-popover target="toolbar-unpaid" triggers="hover" placement="bottomleft">
            <template v-slot:title>{{t('documentsToolbarNotify','documentsToolbarNotify')}}</template>
            {{t('documentsToolbarNotifyDesc','documentsToolbarNotifyDesc')}}
          </b-popover>
        </span>-->
        <span v-if="(clientName == 'look') || (clientName == 'looktest')">
          <span id="toolbar-raise-dispute">
            <fontAwesomeIcon @click="modalCreator({id: 'disputeModal', title: t('documentsSearchDisputeModalHead', 'documentsSearchDisputeModalHead'), level: 'main', open: 'open', entries: 'multi'}, documentsData, $event.target)" :icon="['fa', 'file-invoice']" size="2x" class="mx-2 align-middle" style="cursor: pointer;"/>
          </span>
          <b-popover target="toolbar-raise-dispute" triggers="hover" placement="bottomleft">
            <template v-slot:title>{{t('documentsToolbarSendDocDispute','documentsToolbarSendDocDispute')}}</template>
            {{t('documentsToolbarSendDocDisputeDesc','documentsToolbarSendDocDisputeDesc')}}
          </b-popover>
        </span>
      </span>
    </div>
    <div class="col-sm-12 col-md-4">
      <form v-on:submit.prevent="documentsToolSelected(documentTools.toolSelected, $event.target)" class="d-flex">
        <b-form-select id="document-tools-dropdown" v-model="documentTools.toolSelected" :text="t('documentToolsButtonText', 'documentToolsButtonText')">
          <option :value="null" disabled selected>{{t('documentToolsTitle', 'documentToolsTitle')}}</option>
          <optgroup v-if="clientName == 'look'" :label="t('documentToolsAccountActions', 'documentToolsAccountActions')">
            <option value="contact-payitems" id="pay_items" >{{t('documentToolsPayTheseItems', 'documentToolsPayTheseItems')}}</option>
            <!--<option value="account-customerConfirmedPaid" id="customer_confirmed_paid">{{t('documentToolsTellUsYouPaid', 'documentToolsTellUsYouPaid')}}</option>-->
            <option disabled v-if="(displaySettings.enableContactDropdown && displaySettings.enableContactDropdown.enabled) && (!displaySettings.enableContactDropdown.enabled) && (!displaySettings.enableContactDropdown.raiseQuery)" value="contact-query" id="raise_query">{{t('documentToolsRaiseQuery', 'documentToolsRaiseQuery')}}</option>
          </optgroup>
          <template v-if="(displaySettings.enableContactDropdown && displaySettings.enableContactDropdown.enabled) && (displaySettings.enableContactDropdown.raiseQuery || displaySettings.enableContactDropdown.notifyRemittance)">
            <optgroup v-if="displaySettings.enableContactDropdown.enabled" :label="t('documentToolsContact', 'documentToolsContact')">
              <option v-if="displaySettings.enableContactDropdown.raiseQuery" value="contact-query" id="raise_query">{{ t('documentToolsRaiseQuery','documentToolsRaiseQuery') }}</option>
              <option v-if="displaySettings.enableContactDropdown.notifyRemittance" value="contact-remittance" id="notify_remittance">{{ t('documentToolsNotifyRemittance','documentToolsNotifyRemittance') }}</option>
              <option value="contact-dispute" id="send_dispute">{{ t('documentToolsSendDispute','documentToolsSendDispute') }}</option>
            </optgroup>
          </template>
          <optgroup v-if="displaySettings.watermarkPreferences" :label="t('documentToolsSendCopy', 'documentToolsSendCopy')">
            <option value="email-email" id="forward_email">{{ t('documentToolsEmail','documentToolsEmail') }}</option>
            <option v-if="displaySettings.watermarkPreferences.path_to_default" value="email-default" id="forward_email_default">{{ t('documentToolsEmailWithWatermarkDefault','documentToolsEmailWithWatermarkDefault') }}</option>
            <option v-if="displaySettings.watermarkPreferences.path_to_copy" value="email-copy" id="forward_email_copy">{{ t('documentToolsEmailWithWatermarkCopy','documentToolsEmailWithWatermarkCopy') }}</option>
            <option v-if="displaySettings.watermarkPreferences.path_to_trueandcertified" value="email-certified" id="forward_email_certified">{{ t('documentToolsEmailWithWatermarkCertified','documentToolsEmailWithWatermarkCertified') }}</option>
            <option v-if="displaySettings.watermarkPreferences.path_to_user1" value="email-user1" id="forward_email_user1">{{ t('documentToolsEmailWithSTMTOverdue','documentToolsEmailWithSTMTOverdue') }}</option>
            <option v-if="displaySettings.watermarkPreferences.path_to_user2" value="email-user2" id="forward_email_user2">{{ t('documentToolsEmailWithSTMTOverdue2','documentToolsEmailWithSTMTOverdue2') }}</option>
            <option v-if="displaySettings.watermarkPreferences.path_to_approved" value="email-approved" id="forward_email_approved">{{ t('documentToolsEmailWithWatermarkApproved','documentToolsEmailWithWatermarkApproved') }}</option>
            <option v-if="displaySettings.watermarkPreferences.path_to_directdebit" value="email-directdebit" id="forward_email_directdebit">{{ t('documentToolsEmailWithWatermarkDirectdebit','documentToolsEmailWithWatermarkDirectdebit') }}</option>
            <template v-if="(Number(userLevel) > 0.50)">
              <option value="fax-default" id="forward_fax">{{ t('documentToolsFax','documentToolsFax') }}</option>
              <option value="post" id="forward_post">{{ t('documentToolsPost','documentToolsPost') }}</option>
            </template>
          </optgroup>
          <optgroup :label="t('documentToolsDownloads', 'documentToolsDownloads')">
            <option :disabled="csvGenerating" v-if="(displaySettings.selViewReq == 1) || (Number(userLevel) >= 2.00)" value="download-sumcsv" id="sel_export" >{{ t('documentToolsDownloadDocsSumCSV','documentToolsDownloadDocsSumCSV') }}</option>
            <option disabled v-if="clientName == 'tota'" value="download-consolidated" id="sel_export_consolidated_sheet">{{ t('documentToolsDownloadConsolidatedRepPDF','documentToolsDownloadConsolidatedRepPDF') }}</option>
            <option :disabled="documentsMerging" value="download-default" id="local_download">{{ t('documentToolsDownloadDocs','documentToolsDownloadDocs') }}</option>
            <template v-if="(Number(userLevel) > 0.50)">
              <option value="download-headed" id="local_download_for_post">{{ t('documentToolsDownloadDocsForHeaded','documentToolsDownloadDocsForHeaded') }}</option>
              <option value="download-cover" id="local_download_with_coversheet_for_post">{{ t('documentToolsDownloadDocsForHeadedWithCover','documentToolsDownloadDocsForHeadedWithCover') }}</option>
            </template>
            <option value="download-data" id="data_download">{{ t('documentToolsDownloadDocsData','documentToolsDownloadDocsData') }}</option>
            <template v-if="userLevel == 3.00">
              <option value="download-invite" id="download_invite_letters">{{ t('documentToolsDownloadInviteLettersPDF','documentToolsDownloadInviteLettersPDF') }}</option>
            </template>
            <option :disabled="zipGenerating" v-if="(userLevel >= 2.00) && displaySettings.zipDownload" value="download-zip" id="zip_download">{{ t('documentToolsDownloadDocsZIP','documentToolsDownloadDocsZIP') }}</option>
            <template v-if="displaySettings.enableSpotReport">
              <option value="download-spot-report" id="download_spot_report">{{ t('documentToolsDownloadSpotReport','documentToolsDownloadSpotReport') }}</option>
            </template>
          </optgroup>
          <optgroup v-if="(proof == 'proof') && (Number(userLevel) > 1.60) && (displaySettings.batchStatus != 'rejected')" :label="t('documentToolsDeliveryOptions', 'documentToolsDeliveryOptions')">
            <option value="enable-post" id="do_post">{{t('documentToolsEnablePosting', 'documentToolsEnablePosting')}}</option>
            <option value="enable-fax" id="do_fax">{{t('documentToolsEnableFaxing', 'documentToolsEnableFaxing')}}</option>
            <option value="enable-email" id="do_email">{{t('documentToolsEnableEmailing', 'documentToolsEnableEmailing')}}</option>
            <option value="enable-dataxfer" id="do_dataxfer">{{t('documentToolsEnableDataxfer', 'documentToolsEnableDataxfer')}}</option>
            <option value="disable-post" id="dont_post">{{t('documentToolsDisablePosting', 'documentToolsDisablePosting')}}</option>
            <option value="disable-fax" id="dont_fax">{{t('documentToolsDisableFaxing', 'documentToolsDisableFaxing')}}</option>
            <option value="disable-email" id="dont_email">{{t('documentToolsDisableEmailing', 'documentToolsDisableEmailing')}}</option>
            <option value="disable-dataxfer" id="dont_dataxfer">{{t('documentToolsDisableDataxfer', 'documentToolsDisableDataxfer')}}</option>
            <option value="disable-all" id="dont_send">{{t('documentToolsDisableAll', 'documentToolsDisableAll')}}</option>
            <option value="enable-all" id="reset_delivery">{{t('documentToolsEnableAll', 'documentToolsEnableAll')}}</option>
          </optgroup>
          <optgroup :label="t('documentToolsView', 'documentToolsView')">
            <option v-if="(displaySettings.selViewReq == 1) || (Number(userLevel) > 1.60)" value="view-sel" id="sel_view">{{ t('documentToolsViewSelectedDocs','documentToolsViewSelectedDocs') }}</option>
            <template v-if="(Number(userLevel) > 0.50)">
              <option value="view-customers" id="sel_customers">{{ t('documentToolsViewSelectedCustomers','documentToolsViewSelectedCustomers') }}</option>
              <option v-if="displaySettings.deliveryReports" value="view-delivery" id="sel_delivery">{{ t('documentToolsViewDeliveryReports','documentToolsViewDeliveryReports') }}</option>
            </template>
          </optgroup>
          <optgroup v-if="(Number(userLevel) > 1.60)" :label="t('documentToolsEdit', 'documentToolsEdit')">
            <option value="methods-disable" id="disable_hide"> {{ t('documentToolsDisableAllMethodsAndHide','documentToolsDisableAllMethodsAndHide') }} </option>
            <option value="methods-enable" id="enable_unhide"> {{ t('documentToolsEnableAllMethodsAndUnhide','documentToolsEnableAllMethodsAndUnhide') }}</option>
            <option value="mark-unread" id="mark_unread"> {{ t('documentToolsMarkUnread','documentToolsMarkUnread') }} </option>
            <option value="mark-read" id="mark_read"> {{ t('documentToolsMarkRead','documentToolsMarkRead') }} </option>
            <option v-if="(Number(userLevel) > 2.50)" value="mark-newsnet_hidden" id="mark_hidden_newsnet"> {{ t('documentToolsMarkHidden','documentToolsMarkHidden') }} </option>
            <option value="mark-hidden" id="mark_hidden"> {{ t('documentToolsHide','documentToolsHide') }} </option>
            <option value="mark-unhidden" id="mark_unhidden"> {{ t('documentToolsUnhide','documentToolsUnhide') }} </option>
            <!-- NS-10074 Delete should be available only to newsnet users -->
            <!-- EIPP-199 Delete available to SA ( in proof batch ) and Newsnet users, PW -->
            <template v-if="(Number(userLevel) >= 2.50 && proof == 'proof') || (Number(userLevel) == 3.00)">
              <option v-if="!displaySettings.hideDeleteOption" value="delete" id="delete"> {{ t('documentToolsDelete','documentToolsDelete') }} </option>
            </template>
            <option v-if="(proof == 'proof')" value="reassign-customer" id="reassign_customer"> {{ t('documentToolsAssignSelectedToDifCustomer','documentToolsAssignSelectedToDifCustomer') }} </option>
            <option v-if="displaySettings.userCanAcceptDocuments" value="accept" id="accept"> {{ t('documentToolsAcceptSelected','documentToolsAcceptSelected') }} </option>
          </optgroup>
          <!--
          <optgroup v-if="(!proof) && displaySettings.markReq && displaySettings.isCustomer && (clientName != 'tota')" :label="t('documentToolsDocumentMarks', 'documentToolsDocumentMarks')">
            <template v-if="displaySettings.clientMarks">
              <option v-for="mark in displaySettings.clientMarks" :value="`docstatus-${mark.id}`" :key="mark.id">{{ mark.mark_name }} ({{ mark.mark_symbol }})</option>
            </template>
            <option value="docstatus-null" id="docstatus_null"> {{ t('documentToolsClearStatus','documentToolsClearStatus') }} </option>
          </optgroup>
          <optgroup v-if="(!proof) && (clientName == 'tota') && displaySettings.markReq && ( (belongToPrincipal('INENCO')  && isHeadUser) || displaySettings.isNewsnet)" :label="t('documentToolsDocumentMarks', 'documentToolsDocumentMarks')">
            <template v-if="displaySettings.clientMarks">
              <option v-for="mark in displaySettings.clientMarks" :value="`docstatus-${mark.id}`" :key="mark.id">{{ mark.mark_name }} ({{ mark.mark_symbol }})</option>
            </template>
            <option value="docstatus-null" id="docstatus_null"> {{ t('documentToolsClearStatus','documentToolsClearStatus') }} </option>
          </optgroup>
        -->
          <optgroup v-if="(proof == 'proof') && (userLevel == 3.00)" :label="t('documentToolsPosting', 'documentToolsPosting')">
            <option value="posthouse-change" id="change_post_house"> {{ t('documentToolsChangePostHouse','documentToolsChangePostHouse') }} </option>
          </optgroup>
        </b-form-select>
        <button class="btn btn-primary ml-2" type="submit" :disabled="!documentTools.toolSelected">{{ t('goButtonText','goButtonText') }}</button>
      </form>
    </div>
  </div>
</template>

<script>
import { backendUrl } from '@/helpers/backendUrl.js'
import { mapGetters } from 'vuex'

export default {
  name: 'ToolBar',
  //this component inherits from the Search.vue component
  inject: [
    'proof',
    'modalCreator',
    //'docTypesOnPageInclude',
    'userLevel',
    'clientName',
    'documentTools',
    'documentsData',
    'isHeadUser',
    'belongToPrincipal',
    'searchDocuments',
    'searchArrays',
    'viewOnlySelected'
  ],
  data () {
    return {
      zipGenerating: false,
      documentsMerging: false,
      csvGenerating: false
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    displaySettings: {
      get() {
        return this.$store.getters['documentsStore/getDisplaySettings']
      },
      set(newDisplaySettings) {
        this.$store.commit('documentsStore/setDisplaySettings', newDisplaySettings)
      },
    },
  	is_payment_on() { // NS-9511 DL - new functionality for online payments
  		let enabled = this.$store.getters['onlinePaymentStore/getEnabled']
  		return enabled.is_payment_on || false
  	},
    documents() {
      return this.$store.getters['documentsStore/getDocuments']
    },
    //NS-9694 payment icon visiblity is now checked with a single value instead of two RR
    payment_available_for_documents_on_page() {
      if(this.documents && this.documents.payments) {
        return this.documents.payments.paymentsAllowed
      } else {
        return false
      }
    },
    entries: {
      get() {
        let entries = 'multi'
        if (this.documentsData) {
          if (this.documentsData.docsChecked) {
            if (this.documentsData.docsChecked.length > 1) {
              entries = 'multi'
            } else if (this.documentsData.docsChecked.length === 1) {
              entries = 'single'
            }
          }
        }

        return entries
      }
    }
  },
  methods:{
   getOnlinePayment() { // NS-9511 DL - new functionality for online payments
		this.$store.dispatch('onlinePaymentStore/getEnabled')
	},
    listAll() {
      this.$parent.listAllDocuments()
    },
    routeToPayments(docIds) {
      if(docIds) {
        this.$router.push({ name: 'payment', query: { documents: docIds} })
      }
    },
    unpaid() {
      this.searchArrays.extraFilters['payment_status'] = 'unpaid'
      this.searchArrays.extraFilters['online_statements'] = 'true'
      this.searchDocuments()
    },
    showNoDocumentsError() {
      this.$store.commit('responseInfo', { key: 'noDocumentsSelectedError', status: 'error', responseName: 'documentsView' })
      return false
    },
    documentsToolSelected(toolCode, target) {
      let toolCodeArray = toolCode.split('-')
      let tool = toolCodeArray[0]
      let type = toolCodeArray[1]

      if(this.documentsData) {
        if(this.documentsData.docsChecked) {
          if(Array.isArray(this.documentsData.docsChecked) && !this.documentsData.docsChecked.length) {
            this.showNoDocumentsError()
            return false
          }
        } else {
          this.showNoDocumentsError()
          return false
        }
      } else  {
        this.showNoDocumentsError()
        return false
      }

      switch(tool) {
        case 'email':
          switch(type) {
            case 'default':
              this.modalCreator({id: 'emailModal', title: this.t('documentsSearchEmailModalHead', 'documentsSearchEmailModalHead'), level: 'main', open: 'open', entries: this.entries, wm: 'default', perm_wm_allowed: false}, this.documentsData, target)
            break
            case 'copy':
              this.modalCreator({id: 'emailModal', title: this.t('documentsSearchEmailModalHead', 'documentsSearchEmailModalHead'), level: 'main', open: 'open', entries: this.entries, wm: 'copy', perm_wm_allowed: false}, this.documentsData, target)
            break
            case 'certified':
              this.modalCreator({id: 'emailModal', title: this.t('documentsSearchEmailModalHead', 'documentsSearchEmailModalHead'), level: 'main', open: 'open', entries: this.entries, wm: 'trueandcertified', perm_wm_allowed: false}, this.documentsData, target)
            break
            case 'user1':
              this.modalCreator({id: 'emailModal', title: this.t('documentsSearchEmailModalHead', 'documentsSearchEmailModalHead'), level: 'main', open: 'open', entries: this.entries, wm: 'user1', perm_wm_allowed: false}, this.documentsData, target)
            break
            case 'user2':
              this.modalCreator({id: 'emailModal', title: this.t('documentsSearchEmailModalHead', 'documentsSearchEmailModalHead'), level: 'main', open: 'open', entries: this.entries, wm: 'user2', perm_wm_allowed: false}, this.documentsData, target)
            break
            case 'approved':
              this.modalCreator({id: 'emailModal', title: this.t('documentsSearchEmailModalHead', 'documentsSearchEmailModalHead'), level: 'main', open: 'open', entries: this.entries, wm: 'approved', perm_wm_allowed: false}, this.documentsData, target)
            break
            case 'directdebit':
              this.modalCreator({id: 'emailModal', title: this.t('documentsSearchEmailModalHead', 'documentsSearchEmailModalHead'), level: 'main', open: 'open', entries: this.entries, wm: 'directdebit', perm_wm_allowed: false}, this.documentsData, target)
            break
            default:
              this.modalCreator({id: 'emailModal', title: this.t('documentsSearchEmailModalHead', 'documentsSearchEmailModalHead'), level: 'main', open: 'open', entries: this.entries,  wm: 'none', perm_wm_allowed: true}, this.documentsData, target)
          }
        break
        case 'fax':
          this.modalCreator({id: 'faxModal', title: this.t('documentsSearchFaxModalHead', 'documentsSearchFaxModalHead'), level: 'main', open: 'open', entries: this.entries, type: 'default'}, this.documentsData, target)
        break
        case 'post':
          this.modalCreator({id: 'postModal', title: this.t('documentsSearchPostModalHead', 'documentsSearchPostModalHead'), level: 'main', open: 'open', entries: this.entries, type: 'default'}, this.documentsData, target)
        break
        case 'reassign':
          this.modalCreator({id: 'reassignModal', title: this.t('documentsSearchReassignCustomerModalHead', 'documentsSearchReassignCustomerModalHead'), level: 'main', open: 'open', entries: 'multi', type: 'default'}, this.documentsData, target)
        break
        case 'mark':
          switch(type) {
            case 'unread':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'markDocumentsUnread', documents: this.documentsData.docsChecked, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
                //this.$store.dispatch('alertClearResponse')
              })
            break
            case 'read':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'markDocumentsRead', documents: this.documentsData.docsChecked, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
            case 'newsnet_hidden':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'hideDocumentsUnderNewsnetLevel', documents: this.documentsData.docsChecked, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
            case 'hidden':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'hideDocuments', documents: this.documentsData.docsChecked, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
            case 'unhidden':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'unhideDocuments', documents: this.documentsData.docsChecked, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
          }
        break
        case 'methods':
          switch(type) {
            case 'disable':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'disableAllDocumentMethodsAndHide', documents: this.documentsData.docsChecked, statuses: this.documentsData.statuses, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
            case 'enable':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'enableAllDocumentMethodsAndUnhide', documents: this.documentsData.docsChecked, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
          }
        break
        case 'disable':
          switch(type) {
            case 'all':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'disableAllMethods', documents: this.documentsData.docsChecked, statuses: this.documentsData.statuses, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
            case 'email':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'dontEmail', documents: this.documentsData.docsChecked, statuses: this.documentsData.statuses, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
            case 'fax':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'dontFax', documents: this.documentsData.docsChecked, statuses: this.documentsData.statuses, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
            case 'post':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'dontPost', documents: this.documentsData.docsChecked, statuses: this.documentsData.statuses, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
            case 'dataxfer':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'dontDataTransfer', documents: this.documentsData.docsChecked, statuses: this.documentsData.statuses, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
          }
        break
        case 'enable':
          switch(type) {
            case 'all':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'enableAllMethods', documents: this.documentsData.docsChecked, statuses: this.documentsData.statuses, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
            case 'email':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'enableEmailing', documents: this.documentsData.docsChecked, statuses: this.documentsData.statuses, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
            case 'fax':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'enableFaxing', documents: this.documentsData.docsChecked, statuses: this.documentsData.statuses, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
            case 'post':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'enablePosting', documents: this.documentsData.docsChecked, statuses: this.documentsData.statuses, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
            case 'dataxfer':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'enableDataTransfer', documents: this.documentsData.docsChecked, statuses: this.documentsData.statuses, userLevel: this.userLevel})
              .then(() => {
                let responseStatus = this.getResponseInfo.status
                if(responseStatus != 'noChange') {
                  window.scrollTo(0,0)
                  this.searchDocuments()
                }
              })
            break
          }
        break
        case 'contact':
          switch(type) {
            case 'remittance':
              this.modalCreator({id: 'notifyModal', title: this.t('documentsSearchNotifyRemittanceModalHead', 'documentsSearchNotifyRemittanceModalHead'), level: 'main', open: 'open', entries: 'multi'}, this.documentsData, target)
            break
            case 'query':
              this.modalCreator({id: 'queryModal', title: this.t('documentsSearchRaiseQueryModalHead', 'documentsSearchRaiseQueryModalHead'), level: 'main', open: 'open', entries: 'multi'}, this.documentsData, target)
            break
            case 'dispute':
              this.modalCreator({id: 'disputeModal', title: this.t('documentsSearchDisputeModalHead', 'documentsSearchDisputeModalHead'), level: 'main', open: 'open', entries: 'multi'}, this.documentsData, target)
            break
            case 'payitems':
              this.modalCreator({id: 'paymentModal', title: this.t('documentsSearchRaiseQueryModalHead', 'documentsSearchRaiseQueryModalHead'), level: 'main', open: 'open', entries: 'multi'}, this.documentsData, target)
            break
          }
        break
        case 'view':
          switch(type) {
            case 'sel':
              this.viewOnlySelected(this.documentsData.docsChecked)
            break
            case 'customers':
              /*
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'viewCustomers', documents: this.documentsData.docsChecked, customerId: 0})
              .then(() => {
                this.searchDocuments()
              })
              */
              let customerRefs = []
              for (let index in this.documentsData.statuses) {
                customerRefs.push(this.documentsData.statuses[index].customer)
              }
              this.$router.push({ name: 'manage_customers', query: { customerReference: customerRefs} })
            break
            case 'delivery':
              /*
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'viewDeliveryReports', documents: this.documentsData.docsChecked, customerId: 0})
              .then(() => {
                this.searchDocuments()
              })*/
              this.$router.push({name:'delivery_reports', query: {page: 1, per_page: 20}, params: {docs: this.documentsData.docsChecked}})
            break
          }
        break
        case 'download':
          switch(type) {
            // NS-9981 SP Download selected documents
            case 'default':
              // NS-9981 SP max 100 documents to download
              if(this.documentsData.docsChecked.length > 0) {
                if(this.documentsData.docsChecked.length > this.displaySettings.maxDocumentsDownload) {
                  this.$parent.alertShowing = true
                  this.$parent.informationTextKey = this.t('tooManyDocumentsSelectedInfo', 'tooManyDocumentsSelectedInfo') + ': ' + this.displaySettings.maxDocumentsDownload
                  this.$root.$emit('bv::show::modal', 'informationModal')
                } else {
                  this.documentsMerging = true // Disable the download button and option

                  this.$store.dispatch('downloadDataStore/prepareMergedDocuments', { documents: this.documentsData.docsChecked, userLevel: this.userLevel })
                  .then(response => {
                    this.documentsMerging = false

                    if(response.fileUrl && response.status == 'success') {
                      this.$parent.dataUrl = backendUrl() + '/downloadMergedDocuments/' + response.fileUrl
                      this.$parent.alertShowing = true
                      this.$root.$emit('bv::show::modal', 'downloadModal') // NS-9981 Show the download modal
                    }
                  })
                }
              // NS-9981 SP Haven't selected any documents
              } else {
                this.$parent.alertShowing = true
                this.$parent.informationTextKey = 'NoDocumentsSelectedInfo'
                this.$root.$emit('bv::show::modal', 'informationModal')
              }
              break
            // NS-10052 SP Download selected documents
            case 'headed':
              if(this.documentsData.docsChecked.length > 0) {
                this.$store.dispatch('alertClearResponse')
                 if(this.documentsData.docsChecked && this.documentsData.docsChecked.length > 100) {
                  this.$parent.alertShowing = true
                  this.$parent.informationTextKey = 'tooManyDocumentsSelectedInfo'
                  this.$root.$emit('bv::show::modal', 'informationModal')
                } else {
                  // Disable the download button and option
                  this.documentsMerging = true
                  this.$store.dispatch('downloadDataStore/prepareDocumentsHeaded', { documents: this.documentsData.docsChecked, coversheets: 0})
                  .then(response => {
                    this.documentsMerging = false

                    if(response.fileUrl && response.status == 'success') {
                      this.$parent.dataUrl = backendUrl() + '/downloadMergedDocumentsHeaded/' + response.fileUrl
                      this.$parent.alertShowing = true
                      this.$root.$emit('bv::show::modal', 'downloadModal') // NS-9981 Show the download modal
                    }
                  })
                }
              } else {
                this.$parent.alertShowing = true
                this.$parent.informationTextKey = 'NoDocumentsSelectedInfo'
                this.$root.$emit('bv::show::modal', 'informationModal')
              }

            break
            // NS-10052 SP Download documents with coversheets
            case 'cover':
              if(this.documentsData.docsChecked.length > 0) {
                this.$store.dispatch('alertClearResponse')
                if(this.documentsData.docsChecked && this.documentsData.docsChecked.length > 100) {
                  this.$parent.alertShowing = true
                  this.$parent.informationTextKey = 'tooManyDocumentsSelectedInfo'
                  this.$root.$emit('bv::show::modal', 'informationModal')
                } else {
                  // Disable the download button and option
                  this.documentsMerging = true

                  this.$store.dispatch('downloadDataStore/prepareDocumentsHeaded', { documents: this.documentsData.docsChecked, coversheets: 1 })
                  .then(response => {
                    this.documentsMerging = false

                    if(response.fileUrl && response.status == 'success') {
                      this.$parent.dataUrl = backendUrl() + '/downloadMergedDocumentsHeaded/' + response.fileUrl
                      this.$parent.alertShowing = true
                      this.$root.$emit('bv::show::modal', 'downloadModal') // NS-9981 Show the download modal
                    }
                  })
                }
              } else {
                this.$parent.alertShowing = true
                this.$parent.informationTextKey = 'NoDocumentsSelectedInfo'
                this.$root.$emit('bv::show::modal', 'informationModal')
              }

            break
            case 'sumcsv':
              // NS-10046 VY
              if(this.documentsData.docsChecked.length > 0) {
                this.$store.dispatch('alertClearResponse')
                this.csvGenerating = true
                this.$store.dispatch('downloadDataStore/prepareDocumentsInfoCsv', {documents: this.documentsData.docsChecked})
                    .then(response => {
                      this.csvGenerating = false
                      if (response.status == 'success' && response.fileUrl) {
                        this.$parent.dataUrl = backendUrl() + '/downloadDocumentsInfoToCsv/' + response.fileUrl
                        this.$parent.alertShowing = true
                        this.$root.$emit('bv::show::modal', 'downloadModal')
                      }
                    })
              } else {
                this.$parent.alertShowing = true
                this.$parent.informationTextKey = 'NoDocumentsSelectedInfo'
                this.$root.$emit('bv::show::modal', 'informationModal')
              }
            break
            // NS-9951, download selected docs as zip
            case 'zip':
              // NS-9951 restric max documents download to 100 docs
              // NS-10044 added dynamic document download limit, PW
              if(this.documentsData.docsChecked.length > 0) {
                if(this.documentsData.docsChecked && this.documentsData.docsChecked.length > this.displaySettings.maxDocumentsDownload) {
                  this.$parent.alertShowing = true
                  this.$parent.informationTextKey = this.t('tooManyDocumentsSelectedInfo', 'tooManyDocumentsSelectedInfo') + ': ' + this.displaySettings.maxDocumentsDownload
                  this.$root.$emit('bv::show::modal', 'informationModal')
                } else {
                  this.zipGenerating = true

                  this.$store.dispatch('downloadDataStore/prepareDocumentsZip', { documents: this.documentsData.docsChecked }).then(response => {
                    this.zipGenerating = false

                    if(response.fileUrl && response.status == 'success') {
                      this.$parent.dataUrl = backendUrl() + '/downloadZippedDocuments/' + response.fileUrl
                      this.$parent.alertShowing = true
                      this.$root.$emit('bv::show::modal', 'downloadModal')
                    }
                  })
                }
              } else {
                this.$parent.alertShowing = true
                this.$parent.informationTextKey = 'noZipDocumentsSelectedInfo'
                this.$root.$emit('bv::show::modal', 'informationModal')
              }
            break
            case 'consolidated':
              this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'downloadConsolidated', documents: this.documentsData.docsChecked, userLevel: this.userLevel})
              .then(() => {
                this.searchDocuments()
              })
            break
            // NS-10057, download invite letters, VY
            case 'invite':
              if (this.documentsData.docsChecked.length > 0) {
                if (this.documentsData.docsChecked.length > 1) {
                  this.$parent.alertShowing = true
                  this.$parent.informationTextKey = this.t('tooManyDocumentsSelectedInfo', 'tooManyDocumentsSelectedInfo') + ': ' + 1
                  this.$root.$emit('bv::show::modal', 'informationModal')
                } else {
                  this.$store.dispatch('alertClearResponse')
                  this.modalCreator(
                      {
                        id: 'inviteLettersModal',
                        title: this.t('documentsInviteLettersModalHead', 'documentsInviteLettersModalHead'),
                        level: 'main',
                        open: 'open',
                        entries: 'single',
                        type: 'default'
                      }, {
                        documentId: this.documentsData.docsChecked[0]
                      },
                      target
                  )
                }
              } else {
                this.$parent.alertShowing = true
                this.$parent.informationTextKey = 'NoDocumentsSelectedInfo'
                this.$root.$emit('bv::show::modal', 'informationModal')
              }
              break
            // NS-10047, download data, VY
            case 'data':
              if(this.documentsData.docsChecked.length > 0) {
                this.$store.dispatch('alertClearResponse')
                this.dataGenerating = true
                this.$store.dispatch('downloadDataStore/prepareMergedDocumentsData', {documents: this.documentsData.docsChecked})
                    .then(response => {
                      this.dataGenerating = false
                      if (response.status == 'success' && response.fileUrl) {
                        this.$parent.dataUrl = backendUrl() + '/downloadMergedDocumentsData/' + response.fileUrl
                        this.$parent.alertShowing = true
                        this.$root.$emit('bv::show::modal', 'downloadModal')
                      }
                    })
              } else {
                this.$parent.alertShowing = true
                this.$parent.informationTextKey = 'NoDocumentsSelectedInfo'
                this.$root.$emit('bv::show::modal', 'informationModal')
              }
              break
            // MTVN-11323 Spot report download, PW
            case 'spot':
              if(this.documentsData.docsChecked.length > 0) {
                this.$store.dispatch('alertClearResponse')
                this.dataGenerating = true
                this.$store.dispatch('downloadDataStore/prepareSpotReport', {documents: this.documentsData.docsChecked})
                    .then(response => {
                      this.dataGenerating = false
                    })
              } else {
                this.$parent.alertShowing = true
                this.$parent.informationTextKey = 'NoDocumentsSelectedInfo'
                this.$root.$emit('bv::show::modal', 'informationModal')
              }
              break
          }
        break
        case 'delete':
          this.modalCreator({id: 'deleteModal', title: this.t('documentsSearchDeleteModalHead', 'documentsSearchDeleteModalHead'), level: 'main', open: 'open', entries: 'multi', type: 'default'}, this.documentsData, target)
        /*
          this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'deleteDocuments', documents: this.documentsData.docsChecked, customerId: 0})
          .then(() => {
            this.searchDocuments()
          })
          */
        break
        case 'posthouse':
          this.modalCreator({id: 'posthouseModal', title: this.t('documentsSearchChangePosthouseModalHead', 'documentsSearchChangePosthouseModalHead'), level: 'main', open: 'open', entries: 'multi'}, {docsChecked: this.documentsData.docsChecked}, target)
        break
        case 'accept':
          this.$store.dispatch('documentToolsStore/handleDocumentTool', {action: 'acceptSelectedDocuments', documents: this.documentsData.docsChecked, userLevel: this.userLevel})
          .then(() => {
            let responseStatus = this.getResponseInfo.status
            if(responseStatus != 'noChange') {
              window.scrollTo(0,0)
              this.searchDocuments()
            }
          })
        break
        default:
          console.log(`unknown tool: ${tool} of type: ${type}`)
      }
    }
  },
  created() {
	this.getOnlinePayment(); // NS-9511 DL - new functionality for online payments
  }
}
</script>

<style scoped>
.showhand{
  cursor: pointer;
}

/*TOOLS - ICONS AND DROPDOWN*/
#document-tools-dropdown >>> ul{
  max-height: 350px;
  overflow-x: scroll;
}
.toolbar-hover:hover{
  color: #047bf8;
}

.text-faded-gray{
  color: gray;
  opacity: 0.5;
}
</style>
